// extracted by mini-css-extract-plugin
module.exports = {"center-wrapper":"LoginError_center-wrapper__9FRab","content":"LoginError_content__W1WWC","button-group":"LoginError_button-group__Lp9HS"};